//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        checking_accounts: {
            type: Array
        },
        recurring: {},
        property: {}
    },
    data: function data() {
        return {};
    },

    methods: {
        status: function status(id) {
            return this.recurring && id === this.recurring.payment_account_id ? 'Active' : 'InActive';
        }
    },
    computed: {},
    created: function created() {},
    beforeDestroy: function beforeDestroy() {},
    mounted: function mounted() {}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/payments/RecurringPaymentList.vue
// module id = xRKw
// module chunks = 0 1